import React, { useState, useEffect } from 'react';

import Table from "components/Table/Table.js";
import { Modal } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';

import api from "assets/services/api";



function ModalViewClientsOfSellsman(props) {
    const [clients, setClients] = useState([]);

    useEffect(() => {
        handleShowClients()
    }, [props.props.id])

    async function handleShowClients() {
        const response = await api.get(`/app/client/for/sellsman/${props.props.id}?search=`);
        setClients(response.data);
    }

    function getTable() {
        let teste = [];

        for (let i = 0; i < clients.length; i++) {
            teste[i] = [];
            teste[i].push(clients[i].fantasy_name)
            teste[i].push(clients[i].social_reason)
            teste[i].push(clients[i].address)
            teste[i].push(clients[i].cnpj)
            teste[i].push(clients[i].contact)
        }
        return teste;
    }

    return (
        <Modal
            {...props}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Clientes de {props.props.name}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Table
                    tableHeaderColor="primary"
                    tableHead={["Nome fantasia", "Razão Social", "Endereço", "CPF/CNPJ", "Contato"]}
                    tableData={getTable()}
                />
            </Modal.Body>
        </Modal>
    );
}

export default ModalViewClientsOfSellsman;